import type { GeoNodeId } from '~types';
import { GEONODEIDMAPPING } from '../constants';

export const mapAirportToCity = (geoNodeId: GeoNodeId['id']): GeoNodeId => {
  const geoNodeMapped: number = GEONODEIDMAPPING[geoNodeId];

  return { id: geoNodeMapped || geoNodeId };
};
